module.exports = __webpack_public_path__ + "components/flag/static/square/tv-561e161b3652d9cb948c0a8d5fc653de.svg";